/**
 * @generated SignedSource<<3d8551bac91058afd48adc308f8dec7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PublishState = "ARCHIVED" | "DELETED" | "DRAFT" | "PUBLISHED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RespondForm_folderItem$data = {
  readonly publishState: PublishState;
  readonly " $fragmentType": "RespondForm_folderItem";
};
export type RespondForm_folderItem$key = {
  readonly " $data"?: RespondForm_folderItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"RespondForm_folderItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RespondForm_folderItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishState",
      "storageKey": null
    }
  ],
  "type": "FolderItem",
  "abstractKey": null
};

(node as any).hash = "14e123b147f4db03d79ec8a7bc1e91c5";

export default node;
